<template>
  <div>
    <paper-modal-container :is-visible="true" title="결제 실패" @close="goMyAds">
      <div class="fail-wrapper">
        <div class="state-block">
          <div class="error-icon">✕</div>
          <p class="state-title">카드 등록이 완료되지 않았습니다</p>
          <p class="state-desc">{{ friendlyMessage }}</p>
          <p v-if="campaignId" class="state-desc-sub">캠페인 번호: {{ campaignId }}</p>
          <p v-if="code" class="state-desc-sub">오류 코드: {{ code }}</p>

          <div class="action-row">
            <button type="button" class="secondary-btn" @click="goMyAds">내 광고로 이동</button>
            <button type="button" class="primary-btn" @click="retry">결제 다시 시도</button>
          </div>
        </div>
      </div>
    </paper-modal-container>
  </div>
</template>

<script>
import PaperModalContainer from "@/components/modal/PaperModalContainer.vue";

const PENDING_KEY_PREFIX = "adBillingPending:";

export default {
  name: "AdPaymentFail",
  components: { PaperModalContainer },
  computed: {
    code() {
      return String(this.$route.query.code || "");
    },
    message() {
      return String(this.$route.query.message || "");
    },
    customerKey() {
      return String(this.$route.query.customerKey || "");
    },
    friendlyMessage() {
      if (this.code === "USER_CANCEL" || this.code === "PAY_PROCESS_CANCELED") {
        return "카드 등록이 취소되었습니다.";
      }
      if (this.message) return this.message;
      return "카드 등록 중 오류가 발생했습니다.";
    },
    campaignId() {
      if (!this.customerKey) return "";
      try {
        const raw = sessionStorage.getItem(`${PENDING_KEY_PREFIX}${this.customerKey}`);
        if (!raw) return "";
        const parsed = JSON.parse(raw);
        return parsed?.campaignId || "";
      } catch {
        return "";
      }
    },
  },
  methods: {
    goMyAds() {
      this.cleanup();
      this.$router.push("/my-ads");
    },
    retry() {
      const id = this.campaignId;
      this.cleanup();
      if (id) {
        this.$router.push(`/ads/apply/${id}/checkout`);
      } else {
        this.$router.push("/ads/apply");
      }
    },
    cleanup() {
      if (this.customerKey) {
        sessionStorage.removeItem(`${PENDING_KEY_PREFIX}${this.customerKey}`);
      }
    },
  },
};
</script>

<style scoped>
.fail-wrapper {
  padding: 24px 0;
  max-width: 600px;
  margin: 0 auto;
}

.state-block {
  text-align: center;
  padding: 40px 20px;
}

.error-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f56565 0%, #c53030 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-family: "NanumSquareRoundEB", sans-serif;
  margin: 0 auto 20px;
}

.state-title {
  font-family: "NanumSquareRoundEB", sans-serif;
  font-size: 18px;
  color: #c53030;
  margin: 0 0 8px 0;
}

.state-desc {
  font-family: "NanumSquareRoundR", sans-serif;
  font-size: 14px;
  color: #4a5568;
  margin: 0 0 8px 0;
  line-height: 1.6;
}

.state-desc-sub {
  font-family: "NanumSquareRoundR", sans-serif;
  font-size: 12px;
  color: #718096;
  margin: 0 0 4px 0;
}

.action-row {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 24px;
}

.secondary-btn {
  padding: 12px 22px;
  background: #f1f3f5;
  color: #495057;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  font-family: "NanumSquareRoundB", sans-serif;
  font-size: 14px;
  cursor: pointer;
}

.secondary-btn:hover { background: #e9ecef; }

.primary-btn {
  padding: 12px 22px;
  background: #66bdff;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-family: "NanumSquareRoundEB", sans-serif;
  font-size: 14px;
  cursor: pointer;
}

.primary-btn:hover { background: #4da3ff; }

@media (max-width: 480px) {
  .action-row {
    flex-direction: column;
  }
  .secondary-btn,
  .primary-btn {
    width: 100%;
  }
}
</style>
